
import * as ReactDOM from 'react-dom/client';
import App from './app/app';
import registerServiceWorker, { registerSharedWorker } from './serviceWorkerRegistration';
import { environment } from './environments/environment';
import { attachProvisionalGlobalHandlers, loadSentry, makeReactErrorHandler } from '@nxplatform/helpers/sentry/sentry';

const host = window.location?.host || ''
const agent = window.navigator?.userAgent || '';
const urlParam = new URLSearchParams(window.location.search);
const scriptBlock = !!urlParam.get('scriptBlock');
const navigatorSpeedTest = /(Mozilla\/5\.0 \(Linux; Android 11; moto g power \(2022\)\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0.0.0 Mobile Safari\/537\.36)|(Mozilla\/5\.0 \(Macintosh; Intel Mac OS X 10_15_7\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0\.0\.0 Safari\/537\.36)|(Speed Insights)|(Chrome-Lighthouse)|(PSTS[\d\.]+)/.exec(agent);

const isPageSpeedAgent = [
  /^Mozilla\/5\.0 \(Linux; Android 11; moto g power \(2022\)\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/\d+\.0\.0\.0 Mobile Safari\/537\.36$/,
  /^Mozilla\/5\.0 \(Macintosh; Intel Mac OS X 10_15_7\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/\d+\.0\.0\.0 Safari\/537\.36$/,
].some(
  // @ts-ignore
  regex => regex.test(agent)
);


const sampleRate = navigatorSpeedTest || isPageSpeedAgent ? 1.0 : 0;

// @ts-ignore
if (sampleRate === 1.0 || window.isPrerender) {
  // @ts-ignore
  window.isBot = true;
}

const  isLikelyLighthouse = async () => {

  const detectHeadless = async () => {
    let headless = false;

    const permissionStatus = await navigator.permissions.query({ name: 'notifications' });
    // @ts-ignore
    if (window.Notification) {
      if (Notification?.permission === 'denied' && permissionStatus.state === 'prompt') {
        headless = true;
      }
    }
    // @ts-ignore
    return headless && !window.chrome && navigator.plugins.length === 0;
  };

  return detectHeadless();
};

const detectSpeed = await isLikelyLighthouse();

if ((sampleRate === 1.0 && detectSpeed) || scriptBlock) {
  // @ts-ignore
  window.googlePageSpeed = true;
}

const initSentry = () => {
  if (environment.production && !window.isPrerender && environment.sentryKey) {
    loadSentry(environment);
  }
};

attachProvisionalGlobalHandlers(initSentry);

const errorHandlers = {
  onUncaughtError: makeReactErrorHandler(),
  onCaughtError: makeReactErrorHandler(),
  onRecoverableError: makeReactErrorHandler(),
};

const root = ReactDOM.createRoot(
  document.getElementById('platform') as HTMLElement,
  { ...errorHandlers }
);

root.render(
  <App />,
);

if (environment.production) {
  registerServiceWorker();
  registerSharedWorker();
}
